<template>
    <div class="dashlet">
      <div class="mb-1 pr-0 pl-1 dashlet">
        <div class="ibox-body dashlet">
					<div class="ibox-title style_2 d-flex justify-content-between">
						<div class="ibox-tools">
							<img src="../../assets/img/active_forms.png" alt="Active Forms Widget">
						</div>
						<h5>{{$t('navigations.active forms')}}</h5>
					</div>
					<div class="ibox-content contentheight">
						<h1 class="no-margins">{{ activeformcount }}</h1>
						<small>{{$t('navigations.active forms')}}</small>
					</div>
				</div>
      </div>
    </div>
  </template>
  
  <script>
  /* eslint-disable */
  import axios from "axios";
  import store from "@/store";
  export default {
    name: 'activeforms',
    data() {
    return {
      baseapi: process.env.VUE_APP_Service_URL,
      activeformcount:"",
    }
  },
  async mounted() {
    window.addEventListener("studyIdChanged", async (event) => {
      await this.getactiveformcount();
		});
    await this.getactiveformcount();
  },
    methods:{
        async getactiveformcount() {
            const idtoken = store.getters.getIdToken;
            const currentstudyid = await store.getters.getStudyIs;
			await axios
				.get(
					`${this.baseapi}/forms/forms/activecounts?studyId=${currentstudyid}`,
					{
						headers: {
							"Access-Control-Allow-Origin": "localhost:8080",
							Authorization: "Bearer " + idtoken,
							"Content-Type": "application/json",
						},
					}
				)
				.then((res) => {
					this.activeformcount = res.data;
				})
				.catch((err) => {
					console.log(err);
				});
		},
    }
  };
  </script>
  
  <style>
  .contentheight{
    height: calc(100% - 48px);
  }
  .dashlet{
    width:100%;
    height:100%;
  }
</style>